var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PanelBox',{attrs:{"title-arr":['企业类型', '企业运行状态统计'],"height":"255","other-style":"padding-top: 0"},on:{"change":_vm.onChange}},[_c('echart-pie',{attrs:{"chart-data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }